// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.book-main {
  text-align: center;
  padding-top: 0.333rem;
}

.book-image {
  width: 53.583rem;
}

.book-main {
  position: relative;
  display: inline-flex;
}
.book-main .text-component {
  position: absolute;
  top: 0;
  display: inline-flex;
  height: 100%;
  width: 100%;
}
.book-main .text-component .d-page .left-book-page {
  width: calc((100% - 2rem) / 2);
  position: absolute;
  top: 1.65rem;
  padding-left: 1.667rem;
  padding-right: 1.667rem;
}
.book-main .text-component .d-page .left-book-page .dimension {
  color: var(--color-primary-blue);
  margin-bottom: 0.583rem;
}
.book-main .text-component .d-page .left-book-page .dimension .title {
  font-size: 1rem;
  font-weight: bold;
}
.book-main .text-component .d-page .left-book-page .dimension .dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.833rem;
  font-weight: bold;
  padding: 0.1rem 0.25rem;
  border-radius: 50%;
}
.book-main .text-component .d-page .left-book-page .application-and-transition-period {
  font-size: 1rem;
  color: var(--color-primary-blue);
  line-height: 1.333rem;
  font-weight: bold;
  margin-bottom: 1.375rem;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal {
  margin-bottom: 1.375rem;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .title {
  color: var(--color-primary-blue);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 1rem;
  margin-bottom: 0.667rem;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .title .icon {
  width: 1.333rem;
  height: 1.333rem;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .title .icon img {
  width: 100%;
  height: 100%;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .title .text {
  margin-left: 0.333rem;
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .text-box {
  border-radius: 0.333rem;
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  min-height: 3.333rem;
  padding: 0.542rem 0.667rem;
  color: var(--color-primary-blue);
}
.book-main .text-component .d-page .left-book-page .eu-commission-proposal .text-box .text {
  font-size: 0.9rem;
  line-height: 1.333rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 2.7rem;
  overflow-y: auto;
}
.book-main .text-component .d-page .left-book-page .your-country-position {
  margin-bottom: 1.375rem;
}
.book-main .text-component .d-page .left-book-page .your-country-position .title {
  color: var(--color-primary-blue);
  font-size: 0.75rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  line-height: 1rem;
  margin-bottom: 0.667rem;
}
.book-main .text-component .d-page .left-book-page .your-country-position .title .icon .flag {
  width: 1.333rem;
  height: 1.333rem;
  border: 0.1rem solid var(--color-primary-blue);
  border-radius: 50%;
}
.book-main .text-component .d-page .left-book-page .your-country-position .title .text {
  margin-left: 0.333rem;
  font-size: 1rem;
}
.book-main .text-component .d-page .left-book-page .your-country-position .text-box {
  border-radius: 0.333rem;
  background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  min-height: 7.333rem;
  padding: 0.875rem 0.667rem;
  position: relative;
}
.book-main .text-component .d-page .left-book-page .your-country-position .text-box .text {
  font-size: 0.9rem;
  line-height: 1rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: var(--color-primary-blue);
  margin-bottom: 0.667rem;
}
.book-main .text-component .d-page .left-book-page .your-country-position .text-box .subText {
  font-size: 1rem;
  line-height: 1rem;
  color: #273B5A;
  font-style: italic;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 3.5rem;
  overflow-y: auto;
}
.book-main .text-component .d-page .left-book-page .book-button {
  position: absolute;
  left: 50%;
  font-size: 0.9rem;
  min-width: 5.042rem;
  height: 1.667rem;
  padding-left: 0.833rem;
  padding-right: 0.833rem;
  padding-top: 0.2rem;
  border-width: 0.083rem;
  bottom: 0.5rem;
  background: var(--color-white);
  border-radius: 2rem;
  border-style: solid;
  transform: translate(-50%, 0);
}
.book-main .text-component .d-page .left-book-page .book-button.sensitive {
  color: #5B4C40;
  border-color: #F5DB6C;
}
.book-main .text-component .d-page .left-book-page .book-button.negotiable {
  color: #005840;
  border-color: #C0D19B;
}
.book-main .text-component .d-page .left-book-page .book-button.red_line {
  color: #B82924;
  border-color: #B82924;
}
.book-main .text-component .d-page .right-book-page {
  width: 23.667rem;
  height: 21.667rem;
  position: absolute;
  left: calc((100% - 2.333rem) / 2);
  text-align: left;
  margin-top: 1.333rem;
  margin-right: 0.667rem;
  margin-bottom: 1rem;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.book-main .text-component .d-page .right-book-page .text {
  font-size: 0.75rem;
  color: var(--color-primary-blue);
  line-height: 1.333rem;
  padding-left: 0.667rem;
}
.book-main .text-component .d-page .right-book-page .text.no-alliance {
  height: 100%;
  display: flex;
  text-align: center;
  width: 19.167rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-left: 0;
}
.book-main .text-component .d-page .right-book-page .text .title {
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}
.book-main .text-component .d-page .right-book-page .text .subTitle {
  font-size: 1rem;
}
.book-main .text-component .d-page .right-book-page .text .bilateralSubTitle {
  color: #404953;
  display: grid;
  grid-template-columns: 1.3rem 1fr;
  gap: 0.458rem;
  padding-bottom: 0.417rem;
}
.book-main .text-component .d-page .right-book-page .text .bilateralSubTitle .row {
  background-color: #fff;
  width: 100%;
  height: 0.11rem;
  margin-left: -1rem; /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to left, rgba(207, 231, 237, 0), rgb(207, 231, 237));
  grid-column-start: 1;
  grid-column-end: 3;
}
.book-main .text-component .d-page .right-book-page .text .bilateralSubTitle .alliance-flag {
  width: 1.3rem;
  height: 1.3rem;
  margin-top: 0.25rem;
}
.book-main .text-component .d-page .right-book-page .text .bilateralSubTitle .history-row {
  width: 20rem;
  font-size: 0.9rem;
}
.book-main .text-component .d-page .right-book-page .alliances {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.book-main .text-component .d-page .right-book-page .alliances .country-w-flag:not(:last-child) {
  margin-right: 1rem;
  margin-bottom: 1.333rem;
}
.book-main .text-component .d-page .right-book-page .alliances .subTitle {
  color: #404953;
  margin-bottom: 1.333rem;
}
.book-main .text-component .d-page .right-book-page::-webkit-scrollbar {
  display: none;
}
.book-main .text-component .help-page .left-book-page {
  width: calc((100% - 2rem) / 2);
  position: absolute;
  top: 1.65rem;
  padding-left: 1.667rem;
  padding-right: 1.667rem;
  max-height: 21.917rem;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  background: linear-gradient(to left, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 100%) !important;
}
.book-main .text-component .help-page .left-book-page .main-title {
  color: var(--color-primary-blue);
  font-size: 1rem;
  font-weight: bold;
}
.book-main .text-component .help-page .left-book-page .section {
  padding-left: 1.1rem;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic li {
  color: var(--color-primary-blue);
  font-size: 1rem;
  font-weight: bold;
  border-bottom: 0.083rem solid var(--color-light-blue);
  padding-bottom: 0.604rem;
  margin-bottom: 0.479rem;
  margin-top: 1rem;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .subTitle {
  color: var(--color-secondary-blue);
  font-weight: bold;
  border-bottom: 0.083rem solid var(--color-secondary-blue);
  padding-bottom: 0.479rem;
  margin-bottom: 0.479rem;
  position: relative;
  width: 105%;
  font-size: 1rem;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .subTitle .path {
  width: 0;
  height: 0;
  border-left: 0.7rem solid transparent;
  border-right: 0.7rem solid transparent;
  border-bottom: 0.8rem solid var(--color-secondary-blue);
  position: absolute;
  top: 100%;
  right: 0;
  transform: rotate(-90deg) translate(25%, 94%);
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .subTitle .path:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  transform: translate(-49.9%, 8%);
  border-left: 0.7rem solid transparent;
  border-right: 0.7rem solid transparent;
  border-bottom: 0.8rem solid white;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .subTitle .inner-content {
  width: 95% !important;
  cursor: pointer;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .content {
  color: var(--color-primary-gray);
  font-size: 1rem;
  padding-bottom: 0.479rem;
  margin-bottom: 0.479rem;
  border-bottom: 0.083rem solid var(--color-light-blue);
}
.book-main .text-component .help-page .left-book-page .section .helpTopic .content .inner-content {
  cursor: pointer;
}
.book-main .text-component .help-page .left-book-page .section .helpTopic:nth-last-child(1) {
  margin-bottom: 4rem;
}
.book-main .text-component .help-page .left-book-page .section:after {
  content: "";
  position: fixed;
  top: 19.5rem;
  transform: translateX(-2rem);
  height: 4.583rem;
  width: 24.458rem;
  background: linear-gradient(180deg, rgba(247, 250, 252, 0) 0%, #EBF4F7 100%);
}
.book-main .text-component .help-page .left-book-page::-webkit-scrollbar {
  display: none;
}
.book-main .text-component .help-page .right-book-page {
  width: calc((100% - 3.333rem) / 2);
  position: absolute;
  top: 1.65rem;
  left: calc((100% - 2.333rem) / 2);
}
.book-main .text-component .help-page .right-book-page .inner-container {
  padding: 0.021rem 2.083rem 2.313rem 2.042rem;
  max-height: 20rem;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.book-main .text-component .help-page .right-book-page .inner-container h5 {
  color: var(--color-primary-blue);
  font-size: 1rem;
  font-weight: bold;
}
.book-main .text-component .help-page .right-book-page .inner-container div {
  color: var(--color-primary-blue);
  font-size: 1rem;
  margin-bottom: 1rem;
  line-height: 1.083rem;
}
.book-main .text-component .help-page .right-book-page .inner-container:after {
  content: "";
  position: fixed;
  top: 16.7rem;
  left: 50%;
  height: 5.542rem;
  width: 22.167rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
.book-main .text-component .help-page .right-book-page .inner-container::-webkit-scrollbar {
  display: none;
}
.book-main .text-component .bookmarks-col {
  position: absolute;
  top: 1.65rem;
  right: 0;
  display: flex;
  justify-items: right;
  flex-direction: column;
  height: 100%;
  align-items: flex-end;
}
.book-main .text-component .bookmarks-col .dStyle {
  display: flex;
  padding: 0.833rem;
  text-align: center;
  font-weight: 900;
  border-top-right-radius: 0.417rem;
  border-bottom-right-radius: 0.417rem;
  cursor: pointer;
}
.book-main .text-component .bookmarks-col .d1 {
  height: 4rem;
  width: 2.167rem;
  color: var(--color-white);
  background: var(--color-primary-blue);
}
.book-main .text-component .bookmarks-col .d2 {
  height: 4rem;
  margin-top: 0.625rem;
  width: 2.167rem;
  color: var(--color-white);
  background: var(--color-primary-blue);
}
.book-main .text-component .bookmarks-col .d3 {
  height: 4rem;
  margin-top: 0.625rem;
  width: 2rem;
  color: var(--color-white);
  background: var(--color-primary-blue);
}
.book-main .text-component .bookmarks-col .help {
  height: 4rem;
  width: 1.95rem;
  color: var(--color-primary-blue);
  background: var(--color-light-blue);
  position: absolute;
  bottom: 3.8rem;
}
.book-main .text-component .bookmarks-col .help .bookmark-text-style {
  color: var(--color-primary-blue);
  font-size: 1rem;
}
.book-main .text-component .bookmarks-col .active {
  width: 3.15rem;
  color: var(--color-yellow-box);
  background: var(--color-yellow-bookmark);
}
.book-main .text-component .bookmarks-col .active .bookmark-text-style {
  color: var(--color-primary-blue);
}
.book-main .text-component .bookmarks-col .bookmark-text-style {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: 0.7rem;
  letter-spacing: 0;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/game/book-page/book-page.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;AACJ;AAEM;EACE,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AAAR;AAEQ;EACE,gCAAA;EACA,uBAAA;AAAV;AAEU;EACE,eAAA;EACA,iBAAA;AAAZ;AAGU;EACE,yHAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AADZ;AAKQ;EACE,eAAA;EACA,gCAAA;EACA,qBAAA;EACA,iBAAA;EACA,uBAAA;AAHV;AAMQ;EACE,uBAAA;AAJV;AAMU;EACE,gCAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAJZ;AAMY;EACE,eAAA;EACA,gBAAA;AAJd;AAMc;EACE,WAAA;EACA,YAAA;AAJhB;AAQY;EACE,qBAAA;AANd;AAUU;EACE,uBAAA;EACA,yHAAA;EACA,oBAAA;EACA,0BAAA;EACA,gCAAA;AARZ;AAUY;EAEE,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AATd;AAcQ;EACE,uBAAA;AAZV;AAcU;EACE,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAZZ;AAec;EACE,eAAA;EACA,gBAAA;EACA,8CAAA;EACA,kBAAA;AAbhB;AAiBY;EACE,qBAAA;EACA,eAAA;AAfd;AAmBU;EACE,uBAAA;EACA,kGAAA;EACA,oBAAA;EACA,0BAAA;EACA,kBAAA;AAjBZ;AAmBY;EACE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;AAjBd;AAoBY;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AAlBd;AAuBQ;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AArBV;AAuBU;EACE,cAAA;EACA,qBAAA;AArBZ;AAwBU;EACE,cAAA;EACA,qBAAA;AAtBZ;AAyBU;EACE,cAAA;EACA,qBAAA;AAvBZ;AA4BM;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AA1BR;AA4BQ;EACE,kBAAA;EACA,gCAAA;EACA,qBAAA;EACA,sBAAA;AA1BV;AA4BU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA1BZ;AA6BU;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;AA3BZ;AA8BU;EACE,eAAA;AA5BZ;AA+BU;EACE,cAAA;EACA,aAAA;EACA,iCAAA;EACA,aAAA;EACA,wBAAA;AA7BZ;AA+BY;EACE,sBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA,EACA,aAAA,EACA,4BAAA;EACA,gFAAA;EACA,oBAAA;EACA,kBAAA;AA7Bd;AAgCY;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AA9Bd;AAiCY;EACE,YAAA;EACA,iBAAA;AA/Bd;AAoCQ;EACE,aAAA;EACA,eAAA;EACA,uBAAA;AAlCV;AAoCU;EACE,kBAAA;EACA,uBAAA;AAlCZ;AAqCU;EACE,cAAA;EACA,uBAAA;AAnCZ;AAwCM;EACE,aAAA;AAtCR;AA4CM;EACE,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,uIAAA;AA1CR;AA4CQ;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;AA1CV;AA6CQ;EACE,oBAAA;AA3CV;AA+CY;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,qDAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;AA7Cd;AAgDY;EACE,kCAAA;EACA,iBAAA;EACA,yDAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AA9Cd;AAgDc;EACE,QAAA;EACA,SAAA;EACA,qCAAA;EACA,sCAAA;EACA,uDAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,6CAAA;AA9ChB;AAiDc;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qCAAA;EACA,sCAAA;EACA,iCAAA;AA/ChB;AAkDc;EACE,qBAAA;EACA,eAAA;AAhDhB;AAoDY;EACE,gCAAA;EACA,eAAA;EACA,wBAAA;EACA,uBAAA;EACA,qDAAA;AAlDd;AAoDc;EACE,eAAA;AAlDhB;AAwDU;EACE,mBAAA;AAtDZ;AA0DQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,4EAAA;AAxDV;AA4DM;EACE,aAAA;AA1DR;AA6DM;EACE,kCAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;AA3DR;AA6DQ;EACE,4CAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AA3DV;AA6DU;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;AA3DZ;AA8DU;EACE,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AA5DZ;AAgEQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,4EAAA;AA9DV;AAiEQ;EACE,aAAA;AA/DV;AAqEI;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;AAnEN;AAqEM;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,oCAAA;EACA,eAAA;AAnER;AAsEM;EACE,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qCAAA;AApER;AAuEM;EACE,YAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,qCAAA;AArER;AAwEM;EACE,YAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,qCAAA;AAtER;AAyEM;EACE,YAAA;EACA,cAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;EACA,cAAA;AAvER;AAyEQ;EACE,gCAAA;EACA,eAAA;AAvEV;AA2EM;EACE,cAAA;EACA,8BAAA;EACA,wCAAA;AAzER;AA2EQ;EACE,gCAAA;AAzEV;AA6EM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AA3ER","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.book-main {\n  text-align: center;\n  padding-top: 0.333rem;\n}\n\n.book-image {\n  width: 53.583rem;\n}\n\n.book-main {\n  position: relative;\n  display: inline-flex;\n\n  .text-component {\n    position: absolute;\n    top: 0;\n    display: inline-flex;\n    height: 100%;\n    width: 100%;\n\n    .d-page {\n      .left-book-page {\n        width: calc((100% - 2rem) / 2);\n        position: absolute;\n        top: 1.65rem;\n        padding-left: 1.667rem;\n        padding-right: 1.667rem;\n\n        .dimension {\n          color: var(--color-primary-blue);\n          margin-bottom: 0.583rem;\n\n          .title {\n            font-size: 1rem;\n            font-weight: bold;\n          }\n\n          .dimension-number {\n            background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n            font-size: 0.833rem;\n            font-weight: bold;\n            padding: 0.1rem 0.25rem;\n            border-radius: 50%;\n          }\n        }\n\n        .application-and-transition-period {\n          font-size: 1rem;\n          color: var(--color-primary-blue);\n          line-height: 1.333rem;\n          font-weight: bold;\n          margin-bottom: 1.375rem;\n        }\n\n        .eu-commission-proposal {\n          margin-bottom: 1.375rem;\n\n          .title {\n            color: var(--color-primary-blue);\n            font-size: 1rem;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            line-height: 1rem;\n            margin-bottom: 0.667rem;\n\n            .icon {\n              width: 1.333rem;\n              height: 1.333rem;\n\n              img {\n                width: 100%;\n                height: 100%;\n              }\n            }\n\n            .text {\n              margin-left: 0.333rem;\n            }\n          }\n\n          .text-box {\n            border-radius: 0.333rem;\n            background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n            min-height: 3.333rem;\n            padding: 0.542rem 0.667rem;\n            color: var(--color-primary-blue);\n\n            .text {\n              //padding: 0.833rem;\n              font-size: 0.9rem;\n              line-height: 1.333rem;\n              display: -webkit-box;\n              -webkit-box-orient: vertical;\n              height: 2.7rem;\n              overflow-y: auto;\n            }\n          }\n        }\n\n        .your-country-position {\n          margin-bottom: 1.375rem;\n\n          .title {\n            color: var(--color-primary-blue);\n            font-size: 0.75rem;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            line-height: 1rem;\n            margin-bottom: 0.667rem;\n\n            .icon {\n              .flag {\n                width: 1.333rem;\n                height: 1.333rem;\n                border: 0.1rem solid var(--color-primary-blue);\n                border-radius: 50%;\n              }\n            }\n\n            .text {\n              margin-left: 0.333rem;\n              font-size: 1rem;\n            }\n          }\n\n          .text-box {\n            border-radius: 0.333rem;\n            background: var(--color-light-blue) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);\n            min-height: 7.333rem;\n            padding: 0.875rem 0.667rem;\n            position: relative;\n\n            .text {\n              font-size: 0.9rem;\n              line-height: 1rem;\n              display: -webkit-box;\n              -webkit-box-orient: vertical;\n              -webkit-line-clamp: 2;\n              overflow: hidden;\n              color: var(--color-primary-blue);\n              margin-bottom: 0.667rem;\n            }\n\n            .subText {\n              font-size: 1rem;\n              line-height: 1rem;\n              color: #273B5A;\n              font-style: italic;\n              display: -webkit-box;\n              -webkit-box-orient: vertical;\n              height: 3.5rem;\n              overflow-y: auto;\n            }\n          }\n        }\n\n        .book-button {\n          position: absolute;\n          left: 50%;\n          font-size: 0.9rem;\n          min-width: 5.042rem;\n          height: 1.667rem;\n          padding-left: 0.833rem;\n          padding-right: 0.833rem;\n          padding-top: 0.2rem;\n          border-width: 0.083rem;\n          bottom: 0.5rem;\n          background: var(--color-white);\n          border-radius: 2rem;\n          border-style: solid;\n          transform: translate(-50%, 0);\n\n          &.sensitive {\n            color: #5B4C40;\n            border-color: #F5DB6C;\n          }\n\n          &.negotiable {\n            color: #005840;\n            border-color: #C0D19B;\n          }\n\n          &.red_line {\n            color: #B82924;\n            border-color: #B82924;\n          }\n        }\n      }\n\n      .right-book-page {\n        width: 23.667rem;\n        height: 21.667rem;\n        position: absolute;\n        left: calc((100% - 2.333rem) / 2);\n        text-align: left;\n        margin-top: 1.333rem;\n        margin-right: 0.667rem;\n        margin-bottom: 1rem;\n        overflow-y: auto;\n        -ms-overflow-style: none; /* IE and Edge */\n        scrollbar-width: none; /* Firefox */\n\n        .text {\n          font-size: 0.75rem;\n          color: var(--color-primary-blue);\n          line-height: 1.333rem;\n          padding-left: 0.667rem;\n\n          &.no-alliance {\n            height: 100%;\n            display: flex;\n            text-align: center;\n            width: 19.167rem;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            margin: auto;\n            padding-left: 0;\n          }\n\n          .title {\n            font-weight: bold;\n            margin-bottom: 0.5rem;\n            font-size: 1rem;\n          }\n\n          .subTitle {\n            font-size: 1rem;\n          }\n\n          .bilateralSubTitle {\n            color: #404953;\n            display: grid;\n            grid-template-columns: 1.3rem 1fr;\n            gap: 0.458rem;\n            padding-bottom: 0.417rem;\n\n            .row {\n              background-color: #fff;\n              width: 100%;\n              height: 0.11rem;\n              margin-left: -1rem;\n              background: -moz-linear-gradient(left, rgba(207, 231, 237, 0), rgba(207, 231, 237, 1)); /* FF3.6-15 */\n              background: -webkit-linear-gradient(left, rgba(207, 231, 237, 0), rgba(207, 231, 237, 1)); /* Chrome10-25,Safari5.1-6 */\n              background: linear-gradient(to left, rgba(207, 231, 237, 0), rgba(207, 231, 237, 1));\n              grid-column-start: 1;\n              grid-column-end: 3;\n            }\n\n            .alliance-flag {\n              width: 1.3rem;\n              height: 1.3rem;\n              margin-top: 0.25rem;\n            }\n\n            .history-row {\n              width: 20rem;\n              font-size: 0.9rem;\n            }\n          }\n        }\n\n        .alliances {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: flex-start;\n\n          .country-w-flag:not(:last-child) {\n            margin-right: 1rem;\n            margin-bottom: 1.333rem;\n          }\n\n          .subTitle {\n            color: #404953;\n            margin-bottom: 1.333rem;\n          }\n        }\n      }\n\n      .right-book-page::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    .help-page {\n\n      .left-book-page {\n        width: calc((100% - 2rem) / 2);\n        position: absolute;\n        top: 1.65rem;\n        padding-left: 1.667rem;\n        padding-right: 1.667rem;\n        max-height: 21.917rem;\n        overflow-y: scroll;\n        -ms-overflow-style: none; /* IE and Edge */\n        scrollbar-width: none; /* Firefox */\n        background: linear-gradient(to left, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 100%) !important;\n\n        .main-title {\n          color: var(--color-primary-blue);\n          font-size: 1rem;\n          font-weight: bold;\n        }\n\n        .section {\n          padding-left: 1.1rem;\n\n          .helpTopic{\n\n            li {\n              color: var(--color-primary-blue);\n              font-size: 1rem;\n              font-weight: bold;\n              border-bottom: 0.083rem solid var(--color-light-blue);\n              padding-bottom: 0.604rem;\n              margin-bottom: 0.479rem;\n              margin-top: 1rem;\n            }\n  \n            .subTitle {\n              color: var(--color-secondary-blue);\n              font-weight: bold;\n              border-bottom: 0.083rem solid var(--color-secondary-blue);\n              padding-bottom: 0.479rem;\n              margin-bottom: 0.479rem;\n              position: relative;\n              width: 105%;\n              font-size: 1rem;\n  \n              .path {\n                width: 0;\n                height: 0;\n                border-left: 0.7rem solid transparent;\n                border-right: 0.7rem solid transparent;\n                border-bottom: 0.8rem solid var(--color-secondary-blue);\n                position: absolute;\n                top: 100%;\n                right: 0;\n                transform: rotate(-90deg) translate(25%, 94%);\n              }\n  \n              .path:after {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                left: 0;\n                width: 0;\n                height: 0;\n                transform: translate(-49.9%, 8%);\n                border-left: 0.7rem solid transparent;\n                border-right: 0.7rem solid transparent;\n                border-bottom: 0.8rem solid white;\n              }\n  \n              .inner-content {\n                width: 95% !important;\n                cursor: pointer;\n              }\n            }\n  \n            .content {\n              color: var(--color-primary-gray);\n              font-size: 1rem;\n              padding-bottom: 0.479rem;\n              margin-bottom: 0.479rem;\n              border-bottom: 0.083rem solid var(--color-light-blue);\n\n              .inner-content {\n                cursor: pointer;\n              }\n            }\n  \n          }\n\n          .helpTopic:nth-last-child(1) {\n            margin-bottom: 4rem;\n          }\n        }\n\n        .section:after {\n          content: \"\";\n          position: fixed;\n          top: 19.5rem;\n          transform: translateX(-2rem);\n          height: 4.583rem;\n          width: 24.458rem;\n          background: linear-gradient(180deg, rgba(247,250,252,0) 0%, #EBF4F7 100%);\n        }\n      }\n\n      .left-book-page::-webkit-scrollbar {\n        display: none;\n      }\n\n      .right-book-page {\n        width: calc((100% - 3.333rem) / 2);\n        position: absolute;\n        top: 1.65rem;\n        left: calc((100% - 2.333rem) / 2);\n\n        .inner-container {\n          padding: 0.021rem 2.083rem 2.313rem 2.042rem;\n          max-height: 20rem;\n          overflow-y: auto;\n          -ms-overflow-style: none; /* IE and Edge */\n          scrollbar-width: none; /* Firefox */\n\n          h5 {\n            color: var(--color-primary-blue);\n            font-size: 1rem;\n            font-weight: bold;\n          }\n\n          div {\n            color: var(--color-primary-blue);\n            font-size: 1rem;\n            margin-bottom: 1rem;\n            line-height: 1.083rem;\n          }\n        }\n\n        .inner-container:after {\n          content: \"\";\n          position: fixed;\n          top: 16.7rem;\n          left: 50%;\n          height: 5.542rem;\n          width: 22.167rem;\n          background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);\n        }\n\n        .inner-container::-webkit-scrollbar {\n          display: none;\n        }\n      }\n\n    }\n\n    .bookmarks-col {\n      position: absolute;\n      top: 1.65rem;\n      right: 0;\n      display: flex;\n      justify-items: right;\n      flex-direction: column;\n      height: 100%;\n      align-items: flex-end;\n\n      .dStyle {\n        display: flex;\n        padding: 0.833rem;\n        text-align: center;\n        font-weight: 900;\n        border-top-right-radius: 0.417rem;\n        border-bottom-right-radius: 0.417rem;\n        cursor: pointer;\n      }\n\n      .d1 {\n        height: 4rem;\n        width: 2.167rem;\n        color: var(--color-white);\n        background: var(--color-primary-blue);\n      }\n\n      .d2 {\n        height: 4rem;\n        margin-top: 0.625rem;\n        width: 2.167rem;\n        color: var(--color-white);\n        background: var(--color-primary-blue);\n      }\n\n      .d3 {\n        height: 4rem;\n        margin-top: 0.625rem;\n        width: 2rem;\n        color: var(--color-white);\n        background: var(--color-primary-blue);\n      }\n\n      .help {\n        height: 4rem;\n        width: 1.95rem;\n        color: var(--color-primary-blue);\n        background: var(--color-light-blue);\n        position: absolute;\n        bottom: 3.8rem;\n\n        .bookmark-text-style {\n          color: var(--color-primary-blue);\n          font-size: 1rem;\n        }\n      }\n\n      .active {\n        width: 3.15rem;\n        color: var(--color-yellow-box);\n        background: var(--color-yellow-bookmark);\n\n        .bookmark-text-style {\n          color: var(--color-primary-blue);\n        }\n      }\n\n      .bookmark-text-style {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: var(--color-white);\n        font-size: 0.7rem;\n        letter-spacing: 0;\n        text-align: center;\n      }\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
